
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#5F6368","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M23.5 21a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM30 10a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2h28zm-9-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1zM11 1a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1z"}}),_c('path',{attrs:{"d":"M27.214 3C29.283 3 31 4.594 31 6.586v20.828C31 29.406 29.283 31 27.214 31H4.786C2.718 31 1 29.406 1 27.414V6.586C1 4.594 2.718 3 4.786 3h22.428zm0 2H4.786C3.79 5 3 5.733 3 6.586v20.828C3 28.267 3.79 29 4.786 29h22.428C28.21 29 29 28.267 29 27.414V6.586C29 5.733 28.21 5 27.214 5z"}})])])
          )
        }
      }
    